<div class="actions-container">
  <div class="actions-left">
    <ng-container *appIsRiskManager>
      <mat-button-toggle-group [formControl]="myScopeControl" aria-label="Font Style">
        <mat-button-toggle [value]="true">My</mat-button-toggle>
        <mat-button-toggle [value]="false">All</mat-button-toggle>
      </mat-button-toggle-group>

      @if (!myScope()) {
        <button mat-button (click)="openFilter()"><mat-icon>filter_list</mat-icon> Filter</button>
      }
    </ng-container>
  </div>

  <div class="keyword-search-right">
    <div class="info-icon">
      <span
        class="material-symbols-outlined"
        matTooltipClass="multi-line-tooltip"
        [matTooltip]="KEYWORD_SEARCH_TOOLTIP_TEXT"
        data-testid="keyword-search-tooltip"
      >
        info
      </span>
    </div>
    <mat-form-field class="keyword-search search-filter-form-field">
      <input matInput type="text" [formControl]="keywordControl" placeholder="Keyword search" />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
